<div
  (click)="navigate()"
  class="mat-card-container">
  <mat-card appearance="outlined" class="site-card">
    <div class="title-container">
      <div class="title-icon">
        <div class="status-icon">
          @if (statusIcon) {
            <fa-icon [icon]="['fas', statusIcon.icon]"
                     class="size-20"
                     [ngClass]="statusIcon.color"></fa-icon>
          }
        </div>
        <div class="title-container">
          <div class="title">{{ site.name }}</div>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>

    <div class="site-status">
      <div>
        <span>Status:</span>
        <span [ngClass]="isActionNeeded ? 'action-needed' : ''">
        {{ site.status }}</span>
      </div>
      @if (!isPendingSite) {
        <div class="fc-link" click="navigate()">
          <span>Details</span>
          <fa-icon [icon]="['fas', 'chevron-right']" class="blue"></fa-icon>
        </div>
      }
    </div>

    <mat-divider></mat-divider>

    <div class="site-info">
      <div class="info site-number">
        <span class="label">Site #:</span>
        <span>{{ site.id }}</span>
      </div>
      <div class="info"></div>
      <div class="info">
        <span class="label">Acres:</span>
        <span>{{ totalAcreage }}</span>
      </div>
      <div class="info">
        <span class="label">Site Since:</span>
        <span>{{ site.createDate | date: 'shortDate' }}</span>
      </div>
      <div class="info">
        <div class="label-container">
          <span class="label">Projection Through {{ twentyYearMark }}:</span>
          <fa-icon
            #tooltip1="matTooltip"
            (click)="tooltip1.toggle()"
            [fixedWidth]="false"
            [icon]="['far', 'circle-info']"
            [matTooltip]="projectionInfoBox(twentyYearMark)"
            class="blue"
            matTooltipClass="fc-tooltip"
            matTooltipPosition="right"
            title="Is Verified"></fa-icon>
        </div>
        <span class="twenty-year-projection">{{ twentyYearProjection }}</span>
      </div>
      <div class="info">
        <div class="label-container">
          <span class="label">{{ site.isFirstYear() ? 'Estimated Annual' : 'Previous Years' }} Revenue:</span>
          <fa-icon
            #tooltip2="matTooltip"
            (click)="tooltip2.toggle()"
            [fixedWidth]="false"
            [icon]="['far', 'circle-info']"
            class="blue"
            [matTooltip]="site.getAnnualRevenueIconText()"
            matTooltipClass="fc-tooltip"
            matTooltipPosition="right"
            title="Is Verified"></fa-icon>
        </div>
        <span class="valuation">{{ projectedRevenue }}</span>
      </div>
    </div>

    <mat-divider class="bottom-divider"></mat-divider>

    <div class="footer">
      <div class="button-container">
        @if (isPendingSite) {
          <div class="delete-container">
            <a (click)="onDeleteSite($event, site)" class="fc-link" href="javascript:void(0)">Delete</a>
          </div>
        } @else {
          <button (click)="viewMap()" class="view-map-link" color="primary" mat-stroked-button>View Map</button>
        }
        @if (actionAndText) {
          <button
            (click)="actionAndText.action()"
            class="large"
            color="primary"
            data-cy="button-action"
            mat-raised-button>
            {{ actionAndText.text }}
          </button>
        }
      </div>
    </div>
  </mat-card>
</div>
